import React, { useEffect, useRef, useState } from "react";
import { PostDto, printDto } from "../../../api/interfaces/Posts";
import { useToaster } from "../../../Toaster/Toaster";
import { useLoader } from "../../../Loader/LoaderContext";
import { useNavigate } from "react-router-dom";
import {
  deleteService,
  getService,
  postService,
} from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import Pagination from "../../Portals/usersMangmnt/Pagination";
type FilterType = {
  role: string[];
  status: string[];
  leads: string[];
  addedByLeads: number[];
  assignedTo: number[];
  statusInPosts: string[];
  serviceFilterInPosts: string[];
  featuredTypeFilter: string[];
  postType: string[];
  pitchedBy: number[];
  country: number[];
  types: string[];
  companyType: string[];
  allPost: string[];
  allEvents: string[];
  allExpiredEvents: string[];
};
interface LeadsTableProps {
  leads: PostDto[]; // Use DTO for leads prop
}
const BannerAddTable: React.FC = () => {
  type SortType = {
    column: string;
    direction: number;
  };
  interface VehicleContent {
    status: string;
    // add other fields that exist in the objects inside content, e.g., id, title, etc.
  }
  const [isAssigned, setIsAssigned] = useState(false);
  const [isAssignable, setIsAssignable] = useState(false);
  const [isStatus, setIsStatus] = useState(false);
  const user = {
    status: "On Hold",
    // Add other user properties if needed
  };
  const [postCount, setPostCount] = useState<any | null>();
  const [name, setName] = useState("");
  const [assignedName, setAssigedName] = useState("");
  const [statusValue, setstatus] = useState("");
  const [isOpenTransfer, setTransfer] = useState(false);
  const { showToast } = useToaster();
  const [tableData, setTableData] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedIds, setSelectedIds] = useState([]);
  const [totalElement, setTotalElements] = useState(0);

  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const [isRefreshPage, setisRefreshPage] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<number | null>(null);
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");
  const toggleDropdown = (index: number) => {
    setActiveDropdown((prevIndex) => (prevIndex === index ? null : index));
  };
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const addPost = () => {
    navigate("/vendorDashboard/activateDashboard/bannerAds/addBanner");
  };
  const viewPost = (data: any) => {
    navigate(
      "/vendorDashboard/activateDashbord/bannerAds/viewBannerads?appUserId=" +
        data?.id
    );
  };

  const queryParams = new URLSearchParams();
  const companyId = queryParams.get("appUserId");
  let vendorId = localStorage.getItem("vendorId");
  console.log("Company ID:", companyId);
  const fetchVehicles = async () => {
    setLoading(true);
    let body: any;
    body = {
      page: currentPage,
      search: searchQuery,
      vendorId: vendorId,
    };
    // }
    try {
      let url: any;
      const response = await postService(API_ENDPOINTS.getEwebsite, body);
      setTableData(response.data.content);
      setTotalPages(response.data.totalPages);
      setTotalElements(response.data.totalElements);
    } catch (error) {
      showToast("error", "error", "");
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };
  useEffect(() => {
    fetchVehicles();
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [currentPage, searchQuery]);
  const handleClickOutside = (event: any) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setActiveDropdown(null);
    }
  };
  const onPageChange = async (page: number) => {
    setCurrentPage(page);
  };

  const onNext = () => {
    if (currentPage < totalPages - 1) {
      onPageChange(currentPage + 1);
    }
  };

  const onPrevious = () => {
    if (currentPage > 0) {
      onPageChange(currentPage - 1);
    }
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    setCurrentPage(0);
  };

  const handleEdit = (data: any) => {
    let nameOfScreen;
    console.log("Edit clicked");
    navigate(
      "/vendorDashboard/activateDashbord/bannerAds/addBanner?appUserId=" +
        data?.id
    );
  };

  const [sort, setSort] = useState<SortType>({ column: "", direction: 1 });
  const handleSort = (column: string) => {
    const direction = sort.column === column && sort.direction == 1 ? 0 : 1;
    setSort({ column, direction });
  };

  return (
    <div className="h-full py-2 w-full relative md:px-8">
      <div className="py-4"></div>
      <div className="flex items-center mb-3 mt-2 cursor-pointer justify-between">
        <div className="flex items-center">
          <>
            <h1 className="text-2xl font-bold mb-2 text-[#2D2E2F] mr-3">
              Banner Ads (Website)
            </h1>
          </>
        </div>
        {/* <div className='flex items-center '>
            {userInfo?.roles === 'PUBLISHER' &&
        <div className='flex items-center gradient-background p-2 text-white font-bold text-sm px-4' onClick={addPost}><span className='mr-2'>+</span>Add Banner</div>
        }
        </div> */}
      </div>

      <div className="overflow-x-auto scroolCls">
        <table className="min-w-full bg-white border border-gray-200 w-full">
          <thead className="bg-gray-100 text-left">
            <tr>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs sticky left-0 bg-gray-100 z-20 w-[50px]">
                #
              </th>

              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs flex items-center">
                <span
                  className="text-gray-600 font-semibold text-xs flex items-center cursor-pointer"
                  onClick={() => handleSort("addedDate")}
                >
                  Uploaded Date
                  <img
                    className={`ml-2 transform transition-transform duration-300 ${
                      sort.column === "addedDate" && sort.direction === 1
                        ? "rotate-180"
                        : ""
                    }`}
                    src="/images/sortArrow.svg"
                  />
                </span>
              </th>
              <th className="px-4 py-3 border-b text-gray-600 font-semibold text-xs w-[250px]">
                Caption
              </th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((user: printDto, index: number) => (
              <tr key={index}>
                <td
                  className="px-4 py-3 border-b text-sm text-gray-900 sticky left-0 bg-white font-semibold z-10 cursor-pointer w-[50px] whitespace-nowrap"
                  onClick={() => viewPost(user)}
                >
                  {user?.uuid || "NA"}
                </td>
                <td className="px-4 py-3 border-b text-sm text-gray-500 bg-white font-normal cursor-pointer whitespace-nowrap w-[150px]">
                  {user?.addedDate}
                </td>

                <td className="px-4 py-3 border-b text-sm text-gray-800 font-medium line-clamp-1">
                  <div className="flex justify-between items-center">
                    <span className="cursor-pointer line-clamp-1">
                      {user?.caption || "NA"}
                    </span>
                    {/* {userInfo?.roles === 'PUBLISHER' &&
    <img
      src="/images/threeDot.svg"
      alt="Menu1"
      className="cursor-pointer ml-5"
      onClick={() => toggleDropdown(index)}
    />}
     {activeDropdown === index   && (
                                <div ref={dropdownRef} className="absolute right-[22px] mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-10 ==">
                                  <div className="py-2">
                                 
                                     <span className='flex px-4 cursor-pointer' onClick={() => handleEdit(user)}>
                                       <img src='/images/editIcon.svg' alt="Edit" />
                                       <a href="#" className="ml-2 block py-2 text-sm text-[#374151] font-normal">
                                         Edit
                                       </a>
                                     </span>
                                  </div>
                                </div>
                              )} */}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {!tableData.length && (
          <p className="text-center p-2 bg-white">No data to display.</p>
        )}

        {totalPages > 1 && (
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            totalElement={totalElement}
            onPageChange={onPageChange}
            onNext={onNext}
            onPrevious={onPrevious}
          />
        )}
      </div>
    </div>
  );
};

export default BannerAddTable;
